export const newGuid = () => {
  // Generar un timestamp en formato hexadecimal, con longitud fija de 12 caracteres
  const timestamp = Date.now().toString(16).padStart(12, "0");

  // Generar una parte aleatoria con formato UUID
  const randomPart = "xxxxxxxx-xxxx-4xxx-yxxx".replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16);
    const v = c === "x" ? r : (r % 4) + 8; // 'y' se genera como 8, 9, A, o B
    return v.toString(16);
  });

  // Combinar la parte aleatoria con el timestamp
  return `${randomPart}-${timestamp}`;
};
